console.log('js works');
mapboxgl.accessToken = document.getElementById('vars').dataset.pk;
const map = new mapboxgl.Map({
  container: 'map', // container ID
  style: 'mapbox://styles/mapbox/outdoors-v12', // style URL
  // center: [-111.0937, 39.3210], // starting position [lng, lat]
  // zoom: 5 // starting zoom
  zoom: 1 // starting zoom
});
// Center map around Utah
const bounds =
[[-114.047823, 36.992079], // southwestern corner of the bounds
[-109.172162, 41.988439]]; // northeastern corner of the bounds
// map.fitBounds(bounds, {
//   padding: 20
// });

import ratingEasiest from '../images/rating_easiest.png';
import ratingBeginner from '../images/rating_beginner.png';
import ratingIntermediate from '../images/rating_intermediate.png';
import ratingAdvanced from '../images/rating_advanced.png';
const icons = [
  {path: ratingEasiest, name: 'rating-easiest'},
  {path: ratingBeginner, name: 'rating-beginnger'},
  {path: ratingIntermediate, name: 'rating-intermediate'},
  {path: ratingAdvanced, name: 'rating-advanced'}
];

const sourceName = 'trails';

// Beginning of trail-map.js
/*
//Add polyline
let polyGeoJSON = {
  "type": "Feature",
  "geometry": {
    "type": "LineString",
    "coordinates": []
  }
};
var PRECISION = 1e5

function decode( value ) {

  var points = []
  var lat = 0
  var lon = 0

  var values = decode.integers( value, function( x, y ) {
    lat += x
    lon += y
    points.push([ lat / PRECISION, lon / PRECISION ])
  })

  return points

}

decode.sign = function( value ) {
  return value & 1 ? ~( value >>> 1 ) : ( value >>> 1 )
}

decode.integers = function( value, callback ) {

  var values = 0
  var x = 0
  var y = 0

  var byte = 0
  var current = 0
  var bits = 0

  for( var i = 0; i < value.length; i++ ) {

    byte = value.charCodeAt( i ) - 63
    current = current | (( byte & 0x1F ) << bits )
    bits = bits + 5

    if( byte < 0x20 ) {
      if( ++values & 1 ) {
        x = decode.sign( current )
      } else {
        y = decode.sign( current )
        callback( x, y )
      }
      current = 0
      bits = 0
    }

  }

  return values

}
stravaPolyline = document.getElementById('map').dataset.polyline;
coordinates = decode(stravaPolyline);
for (let i = 0; i < coordinates.length; i++) {
  coordinates[i] = [
    coordinates[i][1],
    coordinates[i][0]
  ];
}
polyGeoJSON.geometry.coordinates = coordinates;
map.on('load', function () {
  map.addSource('route', { type: 'geojson', data: polyGeoJSON });
  map.addLayer({
    "id": "route",
    "type": "line",
    "source": "route",
    "paint": {
      "line-color": "red",
      "line-opacity": 0.75,
      "line-width": 5
    }
  });
});
// Pass the first coordinates in the LineString to `lngLatBounds` &
// wrap each coordinate pair in `extend` to include them in the bounds
// result.
bounds = coordinates.reduce(function(bounds, coord) {
  return bounds.extend(coord);
}, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));
map.fitBounds(bounds, {
  padding: 30 // add some spacing around the coordinates
});

// End of trail-map.js */

// Purple for race Trails
function circleColor(race) {
  console.log(race);
  return 'purple';
}

function getCoordinatesOfTrails(geojson) {
  var coords = []
  var features = geojson.features;
  features.forEach((feature) => {
      coords.push(feature.geometry.coordinates) ;
      console.log(coords);
  });

  if(coords.length > 0) {
    let bounds = coords.reduce(function(bounds, coord) {
      return bounds.extend(coord);
    }, new mapboxgl.LngLatBounds(coords[0], coords[0]));
    map.fitBounds(bounds, {
      padding: 30 // add some spacing around the coordinates
    });
  }
}
const startingGeojson = JSON.parse(document.getElementById('vars').dataset.geojson);
var isSeason = null;
if($('#vars').data("season")) {
  console.log("season");
  isSeason = $('#vars').data("season")
  getCoordinatesOfTrails(startingGeojson);
}
// const geojsonLines = JSON.parse(document.getElementById('vars').dataset.geojsonlines);
// console.log(typeof(startingGeojson));

map.on('load', () => {

  icons.forEach((icon) => {
    map.loadImage(icon.path, (error, image) => {
      if (error) throw error;
      map.addImage(icon.name, image);
    });
  });

  if(isSeason != null) buildMap(startingGeojson);

});

function buildMap(geojson) {

  // Trail polylines
  // map.addSource('trails-lines', {
  //   type: 'geojson',
  //   data: geojsonLines
  // });

  // map.addLayer({
  //   'id': 'trail-line',
  //   'type': 'line',
  //   'source': 'trails-lines',
  //   "paint": {
  //     "line-color": {
  //       property: 'rating',
  //         stops: [
  //           [0, '#fff'],
  //           [1, '#14E211'],
  //           [2, '#1147E2'],
  //           [3, '#000']
  //         ]
  //     },
  //     "line-opacity": 0.75,
  //     "line-width": 5
  //   }
  // });

  // Add a new source from our GeoJSON data and
  // set the 'cluster' option to true. GL-JS will
  // add the point_count property to your source data.
  map.addSource(sourceName, {
    type: 'geojson',
    data: geojson,
    cluster: true,
    clusterMaxZoom: 14, // Max zoom to cluster points on
    clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
  });

  map.addLayer({
    id: 'clusters',
    type: 'circle',
    source: sourceName,
    filter: ['has', 'point_count'],
    paint: {
      // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
      // with three steps to implement three types of circles:
      //   * Blue, 20px circles when point count is less than 100
      //   * Yellow, 30px circles when point count is between 100 and 750
      //   * Pink, 40px circles when point count is greater than or equal to 750
      'circle-color': [
        'step',
        ['get', 'point_count'],
        '#A954EE',
        50,
        '#47C6D9',
        100,
        '#36393E'
      ],
      'circle-radius': [
        'step',
        ['get', 'point_count'],
        20,
        50,
        30,
        100,
        40
      ]
    }
  });

  map.addLayer({
    id: 'cluster-count',
    type: 'symbol',
    source: sourceName,
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
      'text-size': 12
    }
  });

  // map.loadImage(icons[0], (error, image) => {
  //   if (error) throw error;
  //   map.addImage('custom-marker', image);
  // });

  map.addLayer({
    'id': 'unclustered-point',
    'type': 'symbol',
    'source': sourceName,
    filter: ['!', ['has', 'point_count']],
    'layout': {
      'icon-image': {
        property: 'rating',
          stops: [
            [0, icons[0].name],
            [1, icons[1].name],
            [2, icons[2].name],
            [3, icons[3].name]
          ]
      },
      'icon-size': 0.03
    }
  });

  // map.addLayer({
  //   'id': 'unclustered-point',
  //   'type': 'line',
  //   'source': 'trails',
  //   "paint": {
  //     "line-color": {
  //       property: 'rating',
  //         stops: [
  //           [0, '#fff'],
  //           [1, '#14E211'],
  //           [2, '#1147E2'],
  //           [3, '#000']
  //         ]
  //     },
  //     "line-opacity": 0.75,
  //     "line-width": 5
  //   }
  // });

  // map.addLayer({
  //   id: 'unclustered-point',
  //   type: 'circle',
  //   source: 'trails',
  //   filter: ['!', ['has', 'point_count']],
  //   paint: {
  //     'circle-color': {
  //       property: 'race',
  //         stops: [
  //           [0, '#C680FF'],
  //           [1, '#36393e']
  //         ]
  //     },
  //     'circle-radius': 6,
  //     'circle-stroke-width': 1,
  //     'circle-stroke-color': '#fff'
  //   }
  // });

}

// inspect a cluster on click
map.on('click', 'clusters', (e) => {
  const features = map.queryRenderedFeatures(e.point, {
    layers: ['clusters']
  });
  const clusterId = features[0].properties.cluster_id;
  map.getSource(sourceName).getClusterExpansionZoom(
    clusterId,
    (err, zoom) => {
      if (err) return;

      map.easeTo({
        center: features[0].geometry.coordinates,
        zoom: zoom
      });
    }
  );
});

// When a click event occurs on a feature in
// the unclustered-point layer, open a popup at
// the location of the feature, with
// description HTML from its properties.
map.on('click', 'unclustered-point', (e) => {
  const coordinates = e.features[0].geometry.coordinates.slice();
  const id = e.features[0].properties.id;
  const name = e.features[0].properties.name;

  // Ensure that if the map is zoomed out such that
  // multiple copies of the feature are visible, the
  // popup appears over the copy being pointed to.
  while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  new mapboxgl.Popup()
    .setLngLat(coordinates)
    .setHTML(
      `<a href="/trails/${id}">${name}</a>`
    )
    .addTo(map);
});

map.on('mouseenter', 'clusters', () => {
  map.getCanvas().style.cursor = 'pointer';
});
map.on('mouseleave', 'clusters', () => {
  map.getCanvas().style.cursor = '';
});

function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

function removeLayersBySource(sourceId) {
  if (!map.getSource(sourceId)) {
    // console.warn(`Source with ID "${sourceId}" does not exist on the map.`);
    return;
  }

  // Get all layers from the map's current style
  const layers = map.getStyle().layers;

  if (!layers) {
    // console.warn('No layers found on the map.');
    return;
  }

  // Collect layer IDs that are associated with the specified source
  const layersToRemove = layers
    .filter(layer => layer.source === sourceId)
    .map(layer => layer.id);

  // Remove each identified layer
  layersToRemove.forEach(layerId => {
    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
      // console.log(`Removed layer: ${layerId}`);
    } else {
      // console.warn(`Layer "${layerId}" does not exist or has already been removed.`);
    }
  });

  // Optionally, remove the source if no longer needed
  // Comment out the next lines if you want to keep the source
  try {
    map.removeSource(sourceId);
    // console.log(`Removed source: ${sourceId}`);
  } catch (error) {
    // console.error(`Error removing source "${sourceId}":`, error);
  }
}

// Once user has finished moving the map, get the center coordinates
// and ask user if they want to search there for new trails
if (isSeason == null) {
  map.on('moveend', debounce(() => {
    const center = map.getCenter(); // Returns a LngLat object
    const lng = center.lng;
    const lat = center.lat;

    // console.log(`Map center is now at Longitude: ${lng}, Latitude: ${lat}`);
    
    const params = document.getElementById('vars').dataset.params;
    // Example: params = {"attempts"=>"true", "official"=>"true"}
    // console.log(params);

    let newParams = new URLSearchParams();
    newParams.append('lat', lat);
    newParams.append('lng', lng);
    if (params) {
      let paramObj = JSON.parse(params);
      // Loop through the object and append each key-value pair to newParams
      for (const [key, value] of Object.entries(paramObj)) {
        newParams.append(key, value);
      }
    }

    // Construct the URL
    let baseUrl = '/nearby_trails';
    let url = baseUrl + '?' + newParams.toString();
    // console.log(url);

    $.get( url, function( data ) {
      // console.log(data);
      $("#trail-list").replaceWith(data);
    }).then(() => {
      const newGeojson = JSON.parse(document.getElementById('new-vars').dataset.geojson);
      // console.log(newGeojson);
      // console.log(typeof(newGeojson));

      removeLayersBySource(sourceName);
      buildMap(newGeojson);
    });
  }, 2000));
}


//*/
